export default function BottomLine({ className }) {
  return (
    <div
      className={`h-1 w-16 my-3 rounded-full bg-emerald-500 ${className}`}
    ></div>
  );
}
